var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height:_vm.isAccountPage?'100%':'auto'}),attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"padding-top":"var(--headerHeight)"}}),_vm._v(" "),_c('Footnote',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAccountPage),expression:"isAccountPage"}]},[_c('Translate')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e850894","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 